import { Languages } from 'lucide-react'
import { SeoConfigTable } from './SeoConfigTable'
import { SEO_STR as S } from './seoApi'

/**
 * A12.10 — Hreflang boshqaruvi. Path → til + muqobil URL. CRUD
 * `/admin/seo/hreflang` (fail-soft).
 */
export function HreflangScreen() {
  return (
    <SeoConfigTable
      screenId="A12.10"
      title={S.hreflang}
      addLabel={S.addHreflang}
      path="/admin/seo/hreflang"
      listKey="entries"
      searchKeys={['path', 'lang', 'href']}
      icon={<Languages size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'path', placeholder: '/', mono: true },
        { name: 'lang', placeholder: 'uz-UZ', mono: true },
        { name: 'href', placeholder: 'https://mygram.my/uz/', mono: true },
      ]}
      columns={[
        { key: 'path', header: S.path, type: 'text' },
        { key: 'lang', header: S.lang, type: 'text' },
        { key: 'href', header: S.href, type: 'text' },
      ]}
    />
  )
}
